import { FC, ReactNode } from 'react'
import cn from 'classnames'
import classes from './createLinkSections.module.css'
import CreateLinkSectionTitle from './CreateLinkSectionTitle'

type CreateLinkSectionProps = {
  children?: ReactNode
  className?: string
  /** Убрать верхний разделитель (первый блок после табов и т.п.) */
  flushTop?: boolean
  title?: string
  infoText?: ReactNode
}

/**
 * Визуальная группировка полей create-link:
 * мягкий отступ + hairline между соседними секциями.
 */
const CreateLinkSection: FC<CreateLinkSectionProps> = ({
  children,
  className,
  flushTop = false,
  title,
  infoText,
}) => {
  if (children == null || children === false) return null

  return (
    <div
      className={cn(
        classes.section,
        flushTop && classes.sectionFlushTop,
        className,
      )}
    >
      {title ? (
        <CreateLinkSectionTitle title={title} infoText={infoText} />
      ) : null}
      {children}
    </div>
  )
}

export default CreateLinkSection
